import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchVillages, deleteVillage } from '../../utils/api';
import MasterDataTable from '../../components/MasterDataTable';

const columns = [
  { id: 'villageId', label: 'ID', minWidth: 50 },
  { id: 'villageName', label: 'Village Name', minWidth: 170 },
  {
    id: 'taluka',
    label: 'Taluka',
    minWidth: 170,
    format: (value) => value?.talukaName || '-'
  },
  {
    id: 'district',
    label: 'District',
    minWidth: 170,
    format: (value, row) => row.taluka?.district?.districtName || '-'
  },
  {
    id: 'state',
    label: 'State',
    minWidth: 170,
    format: (value, row) => row.taluka?.district?.state?.stateName || '-'
  }
];

const VillageList = ({ onEdit, searchQuery = '' }) => {
  const [villages, setVillages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadVillages = async () => {
      setLoading(true);
      try {
        const response = await fetchVillages();
        if (cancelled) return;
        setVillages(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching villages:', err);
        if (!cancelled) {
          setError('Failed to load villages. Please try again later.');
          setVillages([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadVillages();
    return () => {
      cancelled = true;
    };
  }, [refreshTrigger]);

  const handleDelete = async (village) => {
    try {
      await deleteVillage(village.villageId, {
        previousData: village,
        identifier: village.villageName
      });
      setRefreshTrigger(prev => prev + 1);
    } catch (err) {
      console.error('Error deleting village:', err);
      alert('Failed to delete village. It may be referenced by other records.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Villages
      </Typography>

      <MasterDataTable
        persistKey="village"
        data={villages}
        columns={columns}
        isLoading={loading}
        searchQuery={searchQuery}
        onEdit={onEdit}
        onDelete={handleDelete}
        emptyMessage="No villages found. Add your first village!"
      />

      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default VillageList;
